import type { ReactNode } from "react";

/** 단계 본문 판 , 제목 + 한 줄 설명 + 오른쪽 부속(배지,버튼) */
export function Section({ title, desc, aside, children }: { title: ReactNode; desc?: ReactNode; aside?: ReactNode; children: ReactNode }) {
  return (
    <section className="ws-section">
      <header className="ws-section-head">
        <div className="min-w-0">
          <h2 className="ws-section-title">{title}</h2>
          {desc && <p className="ws-section-desc">{desc}</p>}
        </div>
        {aside && <div className="flex shrink-0 flex-wrap items-center gap-item">{aside}</div>}
      </header>
      <div className="flex flex-col gap-section">{children}</div>
    </section>
  );
}

/** 판 안의 작은 묶음 */
export function Block({ title, aside, children }: { title: ReactNode; aside?: ReactNode; children: ReactNode }) {
  return (
    <div className="ws-block">
      <div className="ws-block-head">
        <h3 className="ws-block-title">{title}</h3>
        {aside}
      </div>
      {children}
    </div>
  );
}
